import { createFileRoute } from '@tanstack/react-router';
import { openGroupsQuery } from '@/features/duplicates/api';
import { DuplicateGroupsPage } from '@/features/duplicates/pages/DuplicateGroupsPage';
import { duplicatesSearchSchema } from '@/features/duplicates/search';

export const Route = createFileRoute('/_authed/ops/duplicates/')({
  staticData: { help: 'duplicates' },
  validateSearch: duplicatesSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps }) => {
    void queryClient.prefetchQuery(openGroupsQuery(deps));
  },
  component: DuplicateGroupsPage,
});
